const AUTH_RECOVERY_SKIP_PATHS = [
  '/api/auth/check',
  '/api/auth/verify-token',
  '/api/auth/logout',
  '/api/auth/login',
];

const pageLoadTimeMs = Date.now();
const DEPLOY_GRACE_MS = 15000;

export function shouldSkipSessionRecovery(error, nowMs = Date.now(), loadTimeMs = pageLoadTimeMs) {
  if (nowMs - loadTimeMs >= DEPLOY_GRACE_MS) return false;
  if (!error?.response) return true;
  const status = error.response.status;
  return status === 502 || status === 503 || status === 504;
}

export function buildRequestUrl(config, apiBaseUrl = '') {
  const raw = config?.url || '';
  if (raw.startsWith('http')) return raw;
  const base = config?.baseURL || apiBaseUrl;
  return `${base}${raw}`;
}

/** True when the API rejected the session cookie (not module permission). */
export function isSessionAuthFailure(error, apiBaseUrl = '') {
  if (error?.response?.status !== 401) return false;

  const url = buildRequestUrl(error.config || {}, apiBaseUrl);
  if (AUTH_RECOVERY_SKIP_PATHS.some((path) => url.includes(path))) {
    return false;
  }

  const errorCode = String(error.response?.data?.error || '').toLowerCase();
  if (!errorCode) return true;

  return (
    errorCode.includes('not authenticated')
    || errorCode.includes('invalid token')
    || errorCode.includes('no token')
    || errorCode.includes('session invalid')
    || errorCode.includes('verification failed')
  );
}
